function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24,26h-7.051c-0.362,6.173-4.019,11.463-9.246,14.135c4.013,4.581,9.809,7.561,16.297,7.84V26z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.949 26H2.025c.201 4.673 1.803 8.987 4.396 12.536C11.198 36.26 14.581 31.542 14.949 26zM6.421 11.464C3.828 15.013 2.226 19.327 2.025 24h12.924C14.581 18.458 11.198 13.74 6.421 11.464z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.949 24H24V2.025c-6.487.279-12.283 3.259-16.297 7.84C12.93 12.537 16.588 17.827 16.949 24zM33.051 26H26v21.975c6.487-.279 12.283-3.259 16.297-7.84C37.07 37.463 33.412 32.173 33.051 26z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.579 38.536c2.593-3.549 4.195-7.863 4.396-12.536H35.051C35.419 31.542 38.802 36.26 43.579 38.536zM42.297 9.865C38.283 5.284 32.487 2.305 26 2.025V24h7.051C33.412 17.827 37.07 12.537 42.297 9.865z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.579,11.464c-4.777,2.276-8.16,6.993-8.528,12.536h12.924C47.774,19.327,46.172,15.013,43.579,11.464z"
});

function SvgBasketball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.8ce1ca6e.svg";
export { ForwardRef as ReactComponent };